import './functions';
import './logic';
import './statics';
import './variables';
import './virtuals';
import { wrapperBuilder } from './build';

export const BackendWrapper = wrapperBuilder.build();
